import React from "react";

export const getValueColor = (
  valueStr?: string | JSX.Element,
  valueInt?: number
) => {
  if (valueInt) {
    const color = Math.sign(valueInt) === 1 ? "#177E22" : "#BE0017";

    return <div style={{ color }}>{valueStr}</div>;
  }
  return <div style={{ color: "#000000" }}>{valueStr}</div>;
};
